import { GoogleAuthProvider as _GoogleAuthProvider, OAuthProvider } from 'firebase/auth'

export const GoogleAuthProvider = new _GoogleAuthProvider().addScope('email')
export const MicrosoftAuthProvider = new OAuthProvider('microsoft.com').addScope('email')
export const AppleAuthProvider = new OAuthProvider('apple.com').addScope('email')
